import type { VoiceState } from '@aeonia/gaia-client';

/**
 * Whether the card showing `lineText` should pace its text to the voice.
 *
 * True while that exact line is the one being spoken (or its playback just
 * failed or completed). Kept in one place so the page and the timing tests use
 * the same rule instead of two copies that can drift apart.
 */
export function isSpokenLineReveal(voice: VoiceState, lineText: string | null | undefined): boolean {
  return (voice.phase === 'speaking' || voice.phase === 'failed' || voice.playbackComplete === true)
    && !!lineText
    && voice.speakingLine?.text === lineText;
}
